'use strict'

const promisify = require('promisify-es6')
const moduleConfig = require('./utils/module-config')

module.exports = (arg) => {
  const send = moduleConfig(arg)

  return promisify((callback) => {
    send({
      path: 'commands'
    }, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/commands.js
// module id = 378
// module chunks = 0